import React, { useEffect, useState } from "react";
import img from "../../assets/images/Dress Code.jpg";
import Skeleton from "@mui/material/Skeleton";
import CloseIcon from "@mui/icons-material/Close";
import Microlink from "@microlink/react";

const PreviewPostCard = ({ text, setInputs, previewLink, setPreviewLink }) => {
  const [previewData, setPreviewData] = useState(null);
  const [loading, setLoading] = useState(false);

  const extractURL = (str) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const match = str.match(urlRegex);
    return match ? match[0] : null;
  };

  const extractDomain = (url) => {
    try {
      const domain = new URL(url).hostname.replace("www.", "");
      return domain;
    } catch (error) {
      return url;
    }
  };

  const extractFakeTitle = (url) => {
    try {
      const pathname = new URL(url).pathname.split("/").filter(Boolean);
      if (pathname.length > 0) {
        return pathname[pathname.length - 1].replace(/[-_]/g, " ");
      }
      return "Website Preview";
    } catch {
      return "Website Preview";
    }
  };

  // Get favicon or fallback to your own image
  const getThumbnail = (url) => {
    const domain = new URL(url).hostname;
    return `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;
  };

  useEffect(() => {
    if (!text) {
      setPreviewData(null);
      return;
    }

    setLoading(true);
    const url = extractURL(text);

    if (url) {
      const fakeData = {
        title: extractFakeTitle(url),
        description: extractDomain(url),
        image: getThumbnail(url),
        url,
      };

      setTimeout(() => {
        setPreviewData(fakeData);
        setLoading(false);
      }, 1000);
    } else {
      setTimeout(() => {
        setPreviewData({
          title: "Invalid URL",
          description: "",
          image: img,
          url: text,
        });
        setLoading(false);
      }, 1000);
    }
  }, [text]);

  const handleClose = () => {
    setPreviewData(null);
  };

  if (loading) {
    return (
      <div
        style={{
          border: "1px solid #ccc",
          borderRadius: 5,
          padding: 10,
          display: "flex",
          alignItems: "center",
          gap: 10,
          maxWidth: 600,
        }}
      >
        <Skeleton variant="rectangular" width={100} height={70} />
        <div style={{ flex: 1 }}>
          <Skeleton width="60%" height={20} />
          <Skeleton width="40%" height={14} />
        </div>
      </div>
    );
  }

  if (!previewData) return null;

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        border: "1px solid #ccc",
        borderRadius: 8,
        padding: 10,
        maxWidth: 600,
        background: "#fff",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      }}
    >
      {/* Optional close icon */}
      {/* <CloseIcon
        onClick={handleClose}
        style={{
          position: "absolute",
          top: 4,
          right: 4,
          cursor: "pointer",
          fontSize: 20,
          color: "#666",
        }}
      /> */}

      {/* <img
        src={previewData.image}
        onError={(e) => (e.target.src = img)} // fallback image
        alt="preview"
        style={{ width: 80, height: 50, borderRadius: 4, objectFit: "cover" }}
      /> */}

      {/* <div style={{ flex: 1 }}>
        <p style={{ margin: "0 0 4px", fontWeight: 600, fontSize: 16 }}></p>
        <p style={{ margin: 0, fontSize: 14, color: "#666" }}>
          {previewData.description}
        </p>
        <a
          href={previewData.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: 12, color: "#0d6efd" }}
        >
          {previewData.url}
        </a>
      </div> */}
      <Microlink
        url={text}
        size="normal" // 👈 Thoda bada than small
        media="image" // or "logo" or "video"
        style={{
          width: "100%", // Ensures the image takes full width of the container
          height: "auto", // Maintain the aspect ratio
          maxHeight: "100px", // Set a maximum height to control the image size
          objectFit: "cover", // Ensures the image covers the space without distortion
        }}
      />
    </div>
  );
};

export default PreviewPostCard;
